export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/template/argument/query`,
          data
        });
      },

      saveInfo(data) {
          return http.json({
              url: '/template/argument/save',
              data  
          })
      },
      getInfo(data) {
          return http.json({
              url: `/template/argument/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      delete(data) {
          return http.json({
              url: `/template/argument/delete?id=${data[0].id}`,
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/templateArgu.js